import { useQuery } from "@tanstack/react-query";

import { supabase } from "~/integrations/supabase/client";

export interface ActiveProduct {
  id: string;
  short_name: string;
  barcode: string | null;
  net_price: number | null;
  stock: number | null;
}

export function useActiveProducts() {
  return useQuery({
    queryKey: ["active_products"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("active_products")
        .select("id, short_name, barcode, net_price, stock")
        .order("short_name");

      if (error) throw error;
      return data as ActiveProduct[];
    },
  });
}
